import React from 'react';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { CreateNewBudgetForm } from '../../../components/budget/create-new-budget-form';
import { ForecastFormHelpText } from '../../../components/form-elements/forecast-form-help-text/forecast-form-help-text';
import { NewForecastDataSource } from '../../../../dashboard/types';
import { useCreateForecastWizardContext } from '../../../contexts/create-forecast-wizard-context';

export interface BudgetFormWizardScreenProps {
  error?: string | boolean;
  onClose: () => void;
  onCreate: () => void;
}

export const BudgetFormWizardScreen = ({ error, onClose, onCreate }: BudgetFormWizardScreenProps) => {
  const { form, excelField, excelTemplate, kind, view } = useCreateForecastWizardContext();
  const { forecasts } = view.state;

  const { ...formState } = form;
  const { onChange: onChangeExcelFile, uploadStatus, error: excelFileError, file: excelFile } = excelField;
  const { data: excelTemplateData, isLoading: isLoadingExcelTemplate } = excelTemplate;

  return (
    <WizardScreen
      createDisabled={formState.datasource === NewForecastDataSource.FromExcelUpload && !excelFile}
      onCancel={onClose}
      onCreate={onCreate}
      footerMode={FooterMode.CREATE}
    >
      <>
        {error && <WizardFormError mb={3} message={typeof error === 'string' ? error : undefined} />}
        <WizardFormValidationErrorSummary errors={formState.errors} mb={3} />

        <CreateNewBudgetForm
          {...formState}
          excelFileError={excelFileError}
          excelTemplateLink={excelTemplateData?.template_url}
          fileUploadStatus={uploadStatus}
          forecasts={forecasts}
          isLoadingExcelTemplate={isLoadingExcelTemplate}
          onChangeFile={onChangeExcelFile}
        />
        <ForecastFormHelpText kind={kind} />
      </>
    </WizardScreen>
  );
};
